import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./TeachersUIHelpers";

const TeachersUIContext = createContext();

export function useTeachersUIContext() {
  return useContext(TeachersUIContext);
}

export const TeachersUIConsumer = TeachersUIContext.Consumer;

export function TeachersUIProvider({ noticeId, children }) {
  initialFilter.filter.noticeId = noticeId; // Duyuru Id Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);  
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams
  };

  return (
    <TeachersUIContext.Provider value={value}>
      {children}
    </TeachersUIContext.Provider>
  );
}